import React, { useEffect, useMemo, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate, useLocation } from 'react-router-dom';
import { setFilter, getInvoiceModuleName } from '../../components/Common/Utilities';
import { paletteItems } from './paletteModel';

// ⌘K / Ctrl+K anywhere in the new shell. Invoice search sets the Invoices list's saved search (No Filter + text), the
// same values the list stores when a user searches it, then opens the list.
export default function CommandPalette({ open, onClose, nav }) {
	const [query, setQuery] = useState('');
	const [active, setActive] = useState(0);
	const navigate = useNavigate();
	const location = useLocation();
	const items = useMemo(() => paletteItems(nav, query), [nav, query]);
	useEffect(() => { if (open) { setQuery(''); setActive(0); } }, [open]);
	useEffect(() => { setActive(0); }, [query]);

	const run = item => {
		if (!item) return;
		onClose();
		if (item.kind === 'search') {
			const base = [getInvoiceModuleName(item.modelDefId), 'ManageInvoiceDocuments'];
			setFilter([...base, 'weeksToFilter'], 0);
			setFilter([...base, 'searchText'], item.text);
			// The list reads its saved search when it opens; reload it if it is already open.
			if (location.pathname === item.path) window.location.assign(item.path); else navigate(item.path);
			return;
		}
		navigate(item.path);
	};
	const onKey = e => {
		if (e.key === 'ArrowDown') { e.preventDefault(); setActive(a => Math.min(a + 1, items.length - 1)); }
		if (e.key === 'ArrowUp') { e.preventDefault(); setActive(a => Math.max(a - 1, 0)); }
		if (e.key === 'Enter') { e.preventDefault(); run(items[active]); }
	};

	return (
		<Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ className: 'apw2 apw2-palette', 'aria-label': 'Search APWorks' }}>
			<div className="apw2-palette-in">
				<SearchIcon fontSize="small" />
				<input autoFocus value={query} onChange={e => setQuery(e.target.value)} onKeyDown={onKey}
					placeholder="Go to a screen, or search invoices" aria-label="Search APWorks" role="combobox" aria-expanded="true" aria-controls="apw2-palette-list" />
				<kbd>Esc</kbd>
			</div>
			<ul id="apw2-palette-list" role="listbox" className="apw2-palette-list">
				{items.length === 0 && <li className="apw2-palette-empty">No matches</li>}
				{items.map((it, i) => (
					<li key={it.key} role="option" aria-selected={i === active} className={i === active ? 'on' : ''}
						onMouseEnter={() => setActive(i)} onClick={() => run(it)}>
						<span>{it.label}</span><small>{it.hint}</small>
					</li>
				))}
			</ul>
		</Dialog>
	);
}
